import { message as AMessage } from 'antd';

export const Message = AMessage;
